import { matchPath } from 'react-router-dom';

export const comparePaths = (pathname: string, expectedPath: string) => {
	const match = matchPath(expectedPath, pathname);

	return Boolean(match);
};
